/* =====================================================
   LOGIN POPUP MODAL
===================================================== */
document.addEventListener("DOMContentLoaded", function () {
  const loginBtn = document.getElementById('login');
  const popup = document.getElementById('popup__login');

  if (loginBtn && popup) {
    loginBtn.addEventListener('click', function (e) {
      e.preventDefault();

      popup.classList.add('show');
      popup.style.display = 'block';

      if (!document.getElementById('popup-backdrop')) {
        const backdrop = document.createElement('div');
        backdrop.className = 'modal-backdrop fade show';
        backdrop.id = 'popup-backdrop';
        document.body.appendChild(backdrop);
      }

      document.body.classList.add('modal-open');
    });
  }

  window.closePopup = function () {
    popup?.classList.remove('show');
    if (popup) popup.style.display = 'none';

    document.getElementById('popup-backdrop')?.remove();
    document.body.classList.remove('modal-open');
  };

  const dismissBtn = document.querySelector('[data-dismiss="modal"]');
  if (dismissBtn) {
    dismissBtn.addEventListener('click', function () {
      popup?.classList.remove('show');
      if (popup) popup.style.display = 'none';

      document.getElementById('popup-backdrop')?.remove();
      document.body.classList.remove('modal-open');
    });
  }
});


/* =====================================================
   PRODUCT SWATCH IMAGE SWITCH
===================================================== */
document.querySelectorAll('.product--item.item.col').forEach(productItem => {
  productItem.querySelectorAll('.item-swatch li').forEach(li => {
    li.addEventListener('click', function (e) {
      e.preventDefault();

      const img = li.querySelector('label')?.getAttribute('data-img');
      const mainImage = productItem.querySelector('#main-product-image');

      if (!img || !mainImage) return;

      mainImage.src = img;
      mainImage.dataset.src = img;
      mainImage.srcset = `${img} 1080w`;
      mainImage.dataset.srcset = `${img} 1080w`;
    });
  });
});


/* =====================================================
   HEADER SEARCH TOGGLE
===================================================== */
const searchBlock = document.querySelector('.site-header__search-block');
const searchBtn = document.querySelector('.header-search-btn');
const closeBtn = document.querySelector('.search-cross-btn');

if (searchBtn && searchBlock) {
  searchBtn.onclick = () => {
    const isHidden = window.getComputedStyle(searchBlock).opacity === '0';

    searchBlock.classList.toggle('active', isHidden);
    searchBlock.style.opacity = isHidden ? '1' : '0';
    searchBlock.style.visibility = isHidden ? 'visible' : 'hidden';
  };
}

closeBtn?.addEventListener('click', e => {
  e.preventDefault();
  searchBlock?.classList.remove('active');
  if (searchBlock) {
    searchBlock.style.opacity = '0';
    searchBlock.style.visibility = 'hidden';
  }
});


/* =====================================================
   PRODUCT IMAGE SCROLL CONTROLS
===================================================== */
const myBtnUp = document.getElementById("myBtnUp");
const myBtnDown = document.getElementById("myBtnDown");
const proFeaturedImage = document.querySelector(".proFeaturedImage");
const scrollRange = document.getElementById("scrollRange");

if (myBtnUp && myBtnDown && proFeaturedImage && scrollRange) {
  myBtnUp.style.display = myBtnDown.style.display = "block";

  proFeaturedImage.addEventListener("scroll", () => {
    const max = proFeaturedImage.scrollHeight - proFeaturedImage.clientHeight;
    scrollRange.value = (proFeaturedImage.scrollTop / max) * 100;
  });

  scrollRange.addEventListener("input", () => {
    const max = proFeaturedImage.scrollHeight - proFeaturedImage.clientHeight;
    proFeaturedImage.scrollTo({
      top: (scrollRange.value / 100) * max,
      behavior: "smooth"
    });
  });

  myBtnUp.onclick = () =>
    proFeaturedImage.scrollBy({ top: -proFeaturedImage.clientHeight * 0.5, behavior: 'smooth' });

  myBtnDown.onclick = () =>
    proFeaturedImage.scrollBy({ top: proFeaturedImage.clientHeight * 0.5, behavior: 'smooth' });
}


// /* =====================================================
//    DE LANGUAGE LINK HANDLING
// ===================================================== */
// if (location.pathname === '/de' || location.pathname.startsWith('/de/')) {
//   document.querySelectorAll('a[href]').forEach(a => {
//     try {
//       const url = new URL(a.href);
//       if (url.hostname === 'funkypunkies.com') {
//         url.pathname = '/de' + url.pathname.replace(/^\/de(-[^/]*)?/, '');
//         a.href = url.toString();
//       }
//     } catch {}
//   });
// }


/* =====================================================
   PRODUCT VARIANTS + ADD TO CART
===================================================== */
document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll('.product--item').forEach(product => {
    const dataScript = product.querySelector('.product-json-new');
    if (!dataScript) return;

    const variants = JSON.parse(dataScript.textContent);
    const selections = { size: null, color: null };

    const bindSwatches = (selector, key) => {
      let swatches = product.querySelectorAll(selector);
      swatches.forEach(s => s.replaceWith(s.cloneNode(true)));
      swatches = product.querySelectorAll(selector);

      const active = product.querySelector(`${selector}.active`) || swatches[0];
      if (active) {
        active.classList.add('active');
        selections[key] = active.dataset.value;
      }

      swatches.forEach(s => {
        s.addEventListener('click', () => {
          swatches.forEach(x => x.classList.remove('active'));
          s.classList.add('active');
          selections[key] = s.dataset.value;
        });
      });
    };

    bindSwatches('.var-new', 'size');
    bindSwatches('.color', 'color');

    product.querySelector('.add-to-cart-btn')?.addEventListener('click', e => {
      e.preventDefault();

      if (!selections.size || !selections.color) {
        return alert("Please select size and color");
      }

      const variant = variants.find(v => {
        return v.options.every(optionValue => {
          return (
            optionValue.toLowerCase() === selections.size?.toLowerCase() ||
            optionValue.toLowerCase() === selections.color?.toLowerCase()
          );
        });
      });

      if (!variant) return alert("Variant not found");

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: variant.id, quantity: 1 })
      }).then(() => {
        location.href = Shopify.routes.root + 'cart';
      });
    });

  });
});

// /* =====================================================
//   Remove Language Selector
// ===================================================== */

// $(document).ready(function(){

//   // If your country dropdown changes without reload
//   $(document).on('click', '#select-market-country .select-option div', function () {

//     setTimeout(function () {
//       var selectedCountryText = $('#select-market-country .select-option-show span').text().trim();

//       if (selectedCountryText !== "United States") {
//         $('#select-market-language').css('display', 'block');
//       } else {
//         $('#select-market-language').css('display', 'none');
//       }

//     }, 200);

//   });

// });



